import React, { useEffect, useState } from 'react';
const CHECKOUT_URL = 'https://tienda.sonriealmitamia.com/cart/44371041878058:1';
export const StickyHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Solo renderiza cuando el usuario ya pasó el hero — no compite con la promesa inicial.
  if (!scrolled) return null;
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md shadow-sm border-b border-gold/20 animate-slide-down" data-id="element-16">
      <div className="container mx-auto px-4 md:px-6 py-2.5 flex items-center justify-between gap-3" data-id="element-17">
        <a href="#top" className="font-display font-extrabold text-base sm:text-lg text-foreground hover:text-coral transition-colors shrink-0" aria-label="Volver al inicio" data-id="element-18">
          ✨ <span className="hidden sm:inline" data-id="element-19">Superpoderes</span>
        </a>
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 bg-coral text-white font-display font-extrabold text-xs sm:text-sm px-4 sm:px-5 py-2 sm:py-2.5 rounded-full shadow-coral hover:scale-[1.03] hover:brightness-110 transition-all whitespace-nowrap" data-id="element-20">
          Comprar <span className="hidden sm:inline" data-id="element-21">por</span> $9.990
        </a>
      </div>
    </header>;
};